module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/conscientiousness/f878772b5c61630133f5363def6b136c.png";